import {Component, OnInit} from '@angular/core';
import {PermissionService} from '@shared/service/permission.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {ROUTE_FROM_MODULE_MAP, ROUTE_FROM_PROFILE_MAP} from '../../../modules-loading.guard';
import {ROOT_NOT_FOUND_PAGE} from '../../../app-routing-roots';
import {LoaderService} from '@shared/service/loader.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationsService} from '../../../notification-center/services/notifications.service';
import {NotificationModel, NotificationType} from '../../../notification-center/models/notification.model';
import {NotificationDialogComponent} from '@shared/components/notification-dialog/notification-dialog.component';
import { logger } from '@app/shared/utilities/logger.model';
import { ModuleService } from '@app/shared/service/module.service';
import { NEMO_MOBILITY_BOOKINGS_RELIEF_CA_PILOT } from '@app/permissions-variables';

@Component({
	selector: 'amd-login-redirect',
	template: '',
})
export class LoginRedirectComponent implements OnInit {

	private routeFromProfileMap: Map<string, string> = ROUTE_FROM_PROFILE_MAP;
	private routeFromModuleMap: Map<string, { route: string; permissions: string[] }[]> = ROUTE_FROM_MODULE_MAP;
	private userPermission: UserPermissionsModel;

	constructor(
		private permissionService: PermissionService,
		private router: Router,
		private route: ActivatedRoute,
		private dialog: MatDialog,
		private loaderService: LoaderService,
		private notificationService: NotificationsService
	) {
		this.userPermission = this.permissionService.getCurrentUserPermissions();
	}

	ngOnInit(): void {
		this.redirect();
	}

	/*
	si occupa del redirect al modulo corretto
	 */
	private redirect(): void {
		this.route.queryParamMap.subscribe(param => {
			if (param.has('redirect_url')) {
				this.navigateWithLoader([param.get('redirect_url')]);
			} else {
				this.redirectFromProfile();
			}
		});
	}

	/*
	redirect in base alle chiavi del profilo
	 */
	private redirectFromProfile(): void {
		this.permissionService.getUserV3Permission().subscribe(userPermissions => {
			if (userPermissions) {
				this.setRedirectRoute(userPermissions);
			} else {
				this.router.navigate([ROOT_NOT_FOUND_PAGE]);
			}
		});
	}

	private setRedirectRoute(user: UserPermissionsModel): void {

		// codice vecchio
		// non è più adatto con Multiprofilo

		// let rootNotFound: boolean = false;
		// user.profiles.forEach(profile => {
		// 	if (this.routeFromProfileMap.has(profile.key) && !rootNotFound) {
		// 		rootNotFound = true;
		// 		this.navigateWithLoader([this.routeFromProfileMap.get(profile.key)]);
		// 	}
		// 	if (this.routeFromModuleMap.has(profile.module.key) && this.routeFromModuleMap.get(profile.module.key).some(item => user.hasPermissions(item.permissions)) && !rootNotFound) {
		// 		rootNotFound = true;
		// 		this.navigateWithLoader([this.routeFromModuleMap.get(profile.module.key).filter(item => user.hasPermissions(item.permissions))[0].route]);
		// 	}
		// });
		// if (!rootNotFound) {
		// 	this.navigateWithLoader([ROOT_NOT_FOUND_PAGE]);
		// }

		//logger.log(this.userPermission.getCurrentProfile().key);

		// Flusso 1) - prende la rotta dal localstorage
		// caso d'uso: viene da LeasePlan e non è loggato
		
		// quì si gestisce il caso raro in cui
		// da Leaseplan si va su NEMO, ma senza essere loggati
		// quindi viene fatto il login automaticamente
		// e si perde l'URL della pagina, 
		// così viene salvato nel localstorage

		const redirectURL = localStorage.getItem('redirect_uri');
		localStorage.removeItem('redirect_uri');

		if (redirectURL) {
			// il profilo relativo al redirectURL viene gestito dentro initCurrentProfile()
			this.navigateWithLoader([redirectURL]);
			return;
		}

		// Flusso 2) - prende la rotta dal in base al profilo corrente
		const route = this.routeFromProfileMap.get(this.userPermission.getCurrentProfile().key);
		if (route) {
			this.navigateWithLoader([route]);
			return;
		}
		
		this.navigateWithLoader([ROOT_NOT_FOUND_PAGE]);
	}

	private navigateWithLoader(commands: string[]): void {
		this.loaderService.display(true);
		this.router.navigate(commands).then(() => {
			this.loaderService.display(false);
			this.checkBrekingNews();
		});
	}

	private openDialog(notifications: NotificationModel[]): void {
		this.dialog.open(NotificationDialogComponent, {
			backdropClass: 'amd-dialog__backdrop--dark',
			panelClass: ['amd-full-screen-simple-table-dialog'],
			disableClose: true,
			data: notifications
		});
		/*const dialogConfig: MatDialogConfig<CoronavirusDialogComponent> = new MatDialogConfig<CoronavirusDialogComponent>();
		dialogConfig.height = 'auto';
		dialogConfig.width = 'auto';
		dialogConfig.backdropClass = 'amd-dialog__backdrop--dark';
		dialogConfig.panelClass = 'amd-full-screen-simple-table-dialog';
		dialogConfig.disableClose = true;

		this.dialog.open(CoronavirusDialogComponent, dialogConfig);*/
	}

	private checkBrekingNews(): void {
		this.notificationService.getUnreadList([NotificationType.BREAKING_NEWS]).subscribe(resp => {
			if (resp && resp.length && resp.length > 0) {
				this.openDialog(resp);
			}
		});
	}
}
